// extracted by mini-css-extract-plugin
export default {"page":"ErrorPage_page__e3Bpx","content":"ErrorPage_content__-VbvM","subtitle":"ErrorPage_subtitle__C-yx7","text":"ErrorPage_text__G+-Ij"};